import { SvgIcon } from '@mui/material'

type RadioButtonUncheckedIconProps = {
    color?: string
    height?: number
    width?: number
}

export const RadioButtonUncheckedIcon = (props: RadioButtonUncheckedIconProps) => {
    const height = props.height ?? 24
    const width = props.width ?? 24
    return (
        <SvgIcon viewBox='0 0 17 10' style={{ height, width }}>
            <svg width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
                <title>radio-unchecked</title>
                <g id='App-design-' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                    <g
                        id='New-listing---details'
                        transform='translate(-20.000000, -1323.000000)'
                        fill='#FFFFFF'
                        stroke={props.color || '#301A36'}
                        strokeWidth='2'
                    >
                        <rect id='radio-unchecked' x='21' y='1324' width='22' height='22' rx='11'></rect>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    )
}
